export const getDictionaryValue = (key, dictionaries) => {
    let value = '';
    if (dictionaries) {
        value = dictionaries.find(item => item.key === key)?.value ?? key;
    } else {
        value = key;
    }
    return value;
}